import { render } from "./ConfigurableColumn.vue?vue&type=template&id=e536a036&ts=true"
import script from "./ConfigurableColumn.vue?vue&type=script&lang=ts"
export * from "./ConfigurableColumn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QTr});
